import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem('id', 25, 'ASC'),
	informacoesAta: { processo: {} },
	paineisInformacoesAbertos: [0, 1],
	listaContratados: [],
	idAtividade: {
		default: null,
		label: 'idAtividade',
		value: null,
	},
	idAtividadeAdesao: {
		default: null,
		label: 'idAtividadeAdesao',
		value: null,
	},
	idAtividadePedido: {
		default: null,
		label: 'idAtividadePedido',
		value: null,
	},
	idOrgao: {
		default: null,
		label: 'Orgão',
		value: null,
	},
	filtro: {
		numeroAtaNumeroProcessoOuDescricao: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
		objeto: {
			default: null,
			label: 'Objeto',
			value: null,
		},
		razaoSocial: {
			default: null,
			label: 'Fornecedor',
			value: null,
		},
		descricaoItemAta: {
			default: null,
			label: 'Descrição da Ata',
			value: null,
		},
		codigoItemAta: {
			default: null,
			label: 'Código do item da Ata',
			value: null,
		},
		atividadeAdesao: {
			default: null,
			label: 'Atividade Adesão',
			value: null,
		},
		atividadePedido: {
			default: null,
			label: 'Atividade Pedido',
			value: null,
		},
		isAtaSemProcesso: {
			default: null,
			label: 'Ata sem Pedido',
			value: null,
		},
		siglaOrgao: {
			default: null,
			label: 'Órgão',
			value: null,
		},
		vigenciaAta: {
			default: 'TODAS',
			label: 'Atas',
			value: null,
		},
	},
}
